@if (filteredMitarbeiter$ | async; as filteredMitarbeiter) {
  @if ((loaded$ | async) === true || (filteredMitarbeiter?.length || 0) > 0) {
    <div class="flex flex-col mt-5 pb-5 gap-2 select-none"
      >
      @if (filteredMitarbeiter.length < 1) {
        <div class="flex items-center justify-center px-4 py-4 text-center mt-3">
          Die Suche hat keine Treffer ergeben.
        </div>
      } @else {
        @for (mitarbeiter of filteredMitarbeiter; track trackByMitarbeiterId($index, mitarbeiter)) {
          <soft-mitarbeiter-card
            mode="selection"
            [ngClass]="mitarbeiter.selected ? 'opacity-100' : 'opacity-75'"
            (tapped)="mitarbeiterTapped(mitarbeiter.mitarbeiter)"
            [mitarbeiter]="mitarbeiter.mitarbeiter"
            [selected]="mitarbeiter.selected">
          </soft-mitarbeiter-card>
        }
      }
    </div>
  } @else {
    <div class="flex flex-col mt-5 pb-5 gap-2">
      <div class="flex soft-card rounded w-full h-20" *softRepeat="5">
        <div class="flex flex-col gap-2.5 items-start pb-1.5 pt-2">
          <div class="h-4 w-20 skeleton rounded"></div>
          <div class="h-4 w-36 skeleton rounded"></div>
        </div>
      </div>
    </div>
  }
}

